/*异常信息*/
const errorInfo = r => require(['@/views/errorInfo/index.vue'], r) // 异常信息展示

export default [
  {
    path: 'errorInfo',
    component: errorInfo,
    name: 'errorInfo',
    meta: {
      name: '不限制'
    },
  }
]



// WEBPACK FOOTER //
// ./src/router/errorInfo.js